import React from 'react';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const SubmitArrowButton = ({ onClick, disabled, style }) => {
  const defaultStyle = {
    position: 'absolute',
    right: '10px',
    bottom: '10px',
    height: '40px',
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return (
    <Button
      type="primary"
      shape="round"
      icon={<ArrowRightOutlined />}
      onClick={onClick}
      disabled={disabled}
      style={{ ...defaultStyle, ...style }}
    />
  );
};

export default SubmitArrowButton; 